import { Component, EventEmitter, inject, Output } from '@angular/core';
import { BusinessService } from '../../../services/business.service';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { FloatLabelModule } from 'primeng/floatlabel';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'brt-businesss-selector',
  standalone: true,
  imports: [CommonModule, AutoCompleteModule, FloatLabelModule],
  templateUrl: './businesss-selector.component.html',
  styleUrl: './businesss-selector.component.css'
})
export class BusinesssSelectorComponent {
  private businessService = inject(BusinessService);

  @Output() onSelectionChanged = new EventEmitter<any|undefined>();

  businesses: any[];
  async searchBusiness(query: string) {
    this.businesses = (await this.businessService.search({ Query: query })).List;
  }

}
